"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecallDateGroupingsType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var RecallDateGroupingsType_Factory = /** @class */ (function () {
    function RecallDateGroupingsType_Factory() {
    }
    RecallDateGroupingsType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    RecallDateGroupingsType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return RecallDateGroupingsType_Factory;
}());
exports.RecallDateGroupingsType_Factory = RecallDateGroupingsType_Factory;
